<template>
  <svg
    :class="['starlive-heart-icon', { 'is-selected': selected }]"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path class="heart-echo" d="M24 41.2 7.8 25.7C-1.4 16.9 4.6 4.8 14.7 5.8c4.1.4 7.1 3 9.3 6.2 2.2-3.2 5.2-5.8 9.3-6.2 10.1-1 16.1 11.1 6.9 19.9L24 41.2Z" />
    <path class="heart-core" d="M24 37.1 10.7 24.4C4.2 18.2 8.1 9.6 15.2 10.3c4 .4 6.7 3.6 8.8 7 2.1-3.4 4.8-6.6 8.8-7 7.1-.7 11 7.9 4.5 14.1L24 37.1Z" />
    <path class="heart-glint" d="M31.7 13.9c2.4-.2 4.1 1 4.8 2.9" stroke-linecap="round" />
  </svg>
</template>

<script>
export default {
  name: "StarLiveHeartIcon",
  props: { selected: { type: Boolean, default: false } }
}
</script>

<style scoped>
.starlive-heart-icon{display:block;width:1em;height:1em;overflow:visible}
.heart-echo{fill:rgba(8,9,13,.5);stroke:rgba(255,255,255,.94);stroke-width:2.4;stroke-linejoin:round}
.heart-core{fill:rgba(255,255,255,.12);stroke:rgba(255,255,255,.5);stroke-width:1;stroke-linejoin:round;transition:fill .2s ease,stroke .2s ease}
.heart-glint{stroke:rgba(255,255,255,.72);stroke-width:2}
.starlive-heart-icon.is-selected .heart-echo{fill:#ff526a;stroke:#ffc06a}
.starlive-heart-icon.is-selected .heart-core{fill:#ff6a62;stroke:#ffd28c}
.starlive-heart-icon.is-selected .heart-glint{stroke:#fff3d7}
</style>
